var _excluded = ["aspectRatio", "classes", "ctaLinkAs", "ctaProps", "ctaText", "ctaURL", "heading", "headingLvl", "imageProps", "mobileVideoProps", "layout", "metaData", "mobileAspectRatio", "mobileImageProps", "overlineHeading", "subContent", "variant", "videoProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import VideoPlayer from '../video-player/index';
import LinkGenerator from '../link-generator';
import CTALink from '../cta-link';
import Image, { constructSizes } from '../image';
require("./card.css");
var styles = {
  "card": "card-3Q9oy",
  "card__wrapperLink": "card__wrapperLink-u99aL",
  "card__horizontal": "card__horizontal-1uY1r",
  "image__responsive": "image__responsive-3yhs1",
  "video__responsive": "video__responsive-5H2P8",
  "media": "media-GwDew",
  "media__visibleMobile": "media__visibleMobile-2O8xy",
  "media__hiddenMobile": "media__hiddenMobile-3fQuu",
  "mediaContainer": "mediaContainer-1O2yI",
  "mediaVideoWrapperResponsive": "mediaVideoWrapperResponsive-1vRQT",
  "mediaWrapper": "mediaWrapper-1377g",
  "mediaWrapper__responsive": "mediaWrapper__responsive-i03_K",
  "mediaWrapper__link": "mediaWrapper__link-_hDQ2",
  "mediaWrapper__portrait": "mediaWrapper__portrait-whJ82",
  "mediaWrapper__landscape": "mediaWrapper__landscape-3ZbSf",
  "mediaWrapper__square": "mediaWrapper__square-1adDj",
  "mediaWrapper__mobilePortrait": "mediaWrapper__mobilePortrait-2awD2",
  "mediaWrapper__mobileLandscape": "mediaWrapper__mobileLandscape-2tlrQ",
  "mediaWrapper__mobileSquare": "mediaWrapper__mobileSquare-qJWQ_",
  "content": "content-1lc3K",
  "content__horizontal": "content__horizontal-O8lie",
  "content__transparent": "content__transparent-1cSBN",
  "content_overlineHeading": "content_overlineHeading-VEYcm",
  "content_heading": "content_heading-1-JjZ",
  "content_subContent": "content_subContent---7ae",
  "content_metaData": "content_metaData-2iKSu",
  "content_cta": "content_cta-3T8ss",
  "content_cta_link": "content_cta_link-1Bvsv"
};
import { useBreakpoint } from '../../utils/hooks';
import { BREAKPOINTS } from '../../utils/breakpoints';
var Card = _ref => {
  var _videoProps, _videoProps2, _videoProps3, _videoProps4, _videoProps5, _videoProps6, _videoProps7, _videoProps8;
  var {
      aspectRatio,
      classes,
      ctaLinkAs,
      ctaProps,
      ctaText,
      ctaURL,
      heading,
      headingLvl,
      imageProps,
      mobileVideoProps,
      layout,
      metaData,
      mobileAspectRatio,
      mobileImageProps,
      overlineHeading,
      subContent,
      variant,
      videoProps: defaultVideoProps

      // eslint-disable-next-line sonarjs/cognitive-complexity
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var breakpoint = useBreakpoint();
  var isMobile = breakpoint === BREAKPOINTS.MOBILE;
  var hasImage = !!(imageProps !== null && imageProps !== void 0 && imageProps.src);
  var hasMobileImage = !!(mobileImageProps !== null && mobileImageProps !== void 0 && mobileImageProps.src);
  var videoProps;
  if (isMobile) {
    if (!hasMobileImage) {
      videoProps = mobileVideoProps || defaultVideoProps;
    }
  } else if (!hasImage) {
    videoProps = defaultVideoProps;
  }

  // Entire card wrapper becomes a link if CTA text is omitted
  var isWrapperLink = !!ctaURL && !ctaText && !ctaLinkAs && !((_videoProps = videoProps) !== null && _videoProps !== void 0 && _videoProps.videoUrl);
  var Wrapper = isWrapperLink ? LinkGenerator : 'div';
  var hasCTA = !!ctaURL && !!ctaText || !!ctaLinkAs;
  var hasImageLink = !!ctaURL && !!ctaText && !ctaLinkAs;
  var ImageWrapper = hasImageLink ? LinkGenerator : 'div';
  var HdgLvl = headingLvl;

  // Clickable image should be ignored by assistive technology when it duplicates the CTA link
  var imageLinkProps = hasImageLink && {
    'aria-hidden': 'true',
    tabIndex: '-1',
    href: ctaURL
  };

  // Default responsive image sizing is based on 3-column wide card
  var DEFAULT_IMAGE_MAX_WIDTH = 624;
  var DEFAULT_IMAGE_SIZES = constructSizes([{
    breakpoint: '1372px',
    slotSize: '312px'
  }, {
    breakpoint: '992px',
    slotSize: '22vw'
  }, {
    breakpoint: '768px',
    slotSize: '31vw'
  }, {
    slotSize: '97vw'
  }]);
  var overlineOutput = typeof overlineHeading === 'string' ? [overlineHeading] : overlineHeading;
  var metaDataOutput = typeof metaData === 'string' ? [metaData] : metaData;
  var mediaWrapperClasses = {
    [styles.mediaWrapper__portrait]: aspectRatio === 'portrait',
    [styles.mediaWrapper__landscape]: aspectRatio === 'landscape',
    [styles.mediaWrapper__square]: aspectRatio === 'square',
    [styles.mediaWrapper__responsive]: aspectRatio,
    [styles.mediaWrapper__mobilePortrait]: mobileAspectRatio === 'portrait',
    [styles.mediaWrapper__mobileLandscape]: mobileAspectRatio === 'landscape',
    [styles.mediaWrapper__mobileSquare]: mobileAspectRatio === 'square'
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: cs(styles.card, 'lll-text-body-2', {
      [styles.card__horizontal]: layout === 'horizontal',
      [styles.card__wrapperLink]: isWrapperLink
    }, classes.container),
    href: isWrapperLink ? ctaURL : undefined
  }, otherProps), (_videoProps2 = videoProps) !== null && _videoProps2 !== void 0 && _videoProps2.videoUrl ? /*#__PURE__*/React.createElement("div", {
    className: cs(styles.mediaContainer, classes.videoContainer)
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles.mediaWrapper, _objectSpread({}, mediaWrapperClasses))
  }, /*#__PURE__*/React.createElement(VideoPlayer, _extends({}, videoProps, {
    allowAudio: !!((_videoProps3 = videoProps) !== null && _videoProps3 !== void 0 && _videoProps3.allowAudio),
    allowFullscreen: !!((_videoProps4 = videoProps) !== null && _videoProps4 !== void 0 && _videoProps4.allowFullscreen),
    className: cs(classes.videoWrapper, (_videoProps5 = videoProps) === null || _videoProps5 === void 0 ? void 0 : _videoProps5.className, {
      [styles.video__responsive]: aspectRatio
    }),
    isMuted: true,
    landscapeSource: (_videoProps6 = videoProps) === null || _videoProps6 === void 0 ? void 0 : _videoProps6.videoUrl,
    type: ((_videoProps7 = videoProps) === null || _videoProps7 === void 0 ? void 0 : _videoProps7.type) || 'autoplay',
    videoClassName: cs((_videoProps8 = videoProps) === null || _videoProps8 === void 0 ? void 0 : _videoProps8.videoClassName, {
      [styles.mediaVideoWrapperResponsive]: aspectRatio
    })
  })))) : /*#__PURE__*/React.createElement("div", {
    className: cs(styles.mediaContainer, classes.imageContainer)
  }, /*#__PURE__*/React.createElement(ImageWrapper, _extends({
    className: cs(styles.mediaWrapper, _objectSpread(_objectSpread({}, mediaWrapperClasses), {}, {
      [classes.imageWrapper]: classes.imageWrapper
    }))
  }, imageLinkProps), hasImage && /*#__PURE__*/React.createElement(Image, _extends({}, imageProps, {
    className: cs(styles.media, {
      [styles.image__responsive]: aspectRatio,
      [imageProps.className]: imageProps.className
    }),
    containerClassName: cs({
      [styles.media__hiddenMobile]: hasMobileImage,
      [imageProps.containerClassName]: imageProps.containerClassName
    }),
    maxWidth: imageProps.maxWidth || DEFAULT_IMAGE_MAX_WIDTH,
    sizes: imageProps.sizes || DEFAULT_IMAGE_SIZES
  })), hasMobileImage && /*#__PURE__*/React.createElement(Image, _extends({}, mobileImageProps, {
    className: cs(styles.media, {
      [styles.image__responsive]: aspectRatio,
      [mobileImageProps.className]: mobileImageProps.className
    }),
    containerClassName: cs(styles.media__visibleMobile, {
      [mobileImageProps.containerClassName]: mobileImageProps.containerClassName
    }),
    maxWidth: mobileImageProps.maxWidth || DEFAULT_IMAGE_MAX_WIDTH,
    sizes: mobileImageProps.sizes || DEFAULT_IMAGE_SIZES
  })))), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.content, {
      [styles.content__horizontal]: layout === 'horizontal',
      [styles.content__transparent]: variant === 'transparent'
    }, classes.textContainer)
  }, !!heading && /*#__PURE__*/React.createElement(HdgLvl, {
    className: cs(styles.content_heading, 'lll-text-xsmall', classes.heading)
  }, heading), !!subContent && /*#__PURE__*/React.createElement("p", {
    className: cs(styles.content_subContent, 'lll-text-body-2', classes.subContent)
  }, subContent), !!overlineHeading && /*#__PURE__*/React.createElement("span", {
    className: cs(styles.content_overlineHeading, 'lll-text-subtitle', classes.overlineHeading)
  }, overlineOutput.map((partial, index) => {
    if (index < overlineOutput.length - 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: partial
      }, partial, /*#__PURE__*/React.createElement("span", {
        className: "lll-separator"
      }));
    }
    return partial;
  })), !!metaData && /*#__PURE__*/React.createElement("span", {
    className: cs(styles.content_metaData, classes.metaData)
  }, metaDataOutput.map((partial, index) => {
    if (index < metaDataOutput.length - 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: partial
      }, partial, /*#__PURE__*/React.createElement("span", {
        className: "lll-separator"
      }));
    }
    return partial;
  })), hasCTA && /*#__PURE__*/React.createElement("span", {
    className: cs(styles.content_cta, classes.ctaText),
    "data-testid": "card-cta-wrapper"
  }, ctaLinkAs !== null && ctaLinkAs !== void 0 ? ctaLinkAs : /*#__PURE__*/React.createElement(CTALink, _extends({}, ctaProps, {
    className: cs(styles.content_cta_link, ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.className),
    href: ctaURL,
    kind: "secondary"
  }), ctaText))));
};
Card.propTypes = {
  /** Crop image to a specific aspect ratio; if omitted, flexbox controls image aspect ratio */
  aspectRatio: PropTypes.oneOf(['portrait', 'landscape', 'square']),
  /** Optional classes to be added to any of the elements within the card */
  classes: PropTypes.shape({
    container: PropTypes.string,
    ctaText: PropTypes.string,
    heading: PropTypes.string,
    imageContainer: PropTypes.string,
    imageWrapper: PropTypes.string,
    metaData: PropTypes.string,
    overlineHeading: PropTypes.string,
    subContent: PropTypes.string,
    textContainer: PropTypes.string,
    videoContainer: PropTypes.string,
    videoWrapper: PropTypes.string
  }),
  /** Custom cta property which can override the default CTALink */
  ctaLinkAs: PropTypes.node,
  /** Accepts same props list as <CTALink /> component */
  ctaProps: PropTypes.shape(_objectSpread(_objectSpread({}, CTALink.propTypes), {}, {
    children: PropTypes.node,
    className: PropTypes.string
  })),
  /** Label for the call to action link; if omitted, the entire card becomes clickable */
  ctaText: PropTypes.string,
  /** URL for the call to action link */
  ctaURL: PropTypes.string,
  /** Text to be used for the heading */
  heading: PropTypes.string,
  /** HTML element to be used for the heading */
  headingLvl: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  /** Accepts same props list as <Image /> component */
  imageProps: PropTypes.shape(_objectSpread(_objectSpread({}, Image.propTypes), {}, {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    maxWidth: PropTypes.number,
    sizes: PropTypes.string,
    src: PropTypes.string
  })),
  /** Layout for the card - image is either stacked on top or inline to the left. Horizontal styling is still TBD. */
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  /** String or array of metadata text */
  metaData: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /** Optional mobile-only aspect ratio - crop image to a specific aspect ratio */
  mobileAspectRatio: PropTypes.oneOf(['portrait', 'landscape', 'square']),
  /** Optional mobile-only image - accepts same props list as <Image /> component */
  mobileImageProps: PropTypes.shape(_objectSpread(_objectSpread({}, Image.propTypes), {}, {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    maxWidth: PropTypes.number,
    sizes: PropTypes.string,
    src: PropTypes.string
  })),
  /** Optional mobile-only video props - accepts same props list as <Video /> component. Only autoplay video is supported. */
  mobileVideoProps: PropTypes.shape(_objectSpread({}, VideoPlayer.propTypes)),
  /** String or array of text for overline heading */
  overlineHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /** Text to be used for the main text content */
  subContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func, PropTypes.node]),
  /** Optional variant prop to change the visual style of the content section */
  variant: PropTypes.oneOf(['default', 'transparent']),
  /** Optional desktop video props - accepts same props list as <Video /> component. Only autoplay video is supported. */
  videoProps: PropTypes.shape(_objectSpread({}, VideoPlayer.propTypes))
};
Card.defaultProps = {
  aspectRatio: null,
  classes: {},
  ctaLinkAs: undefined,
  ctaProps: undefined,
  ctaText: '',
  ctaURL: '',
  heading: '',
  headingLvl: 'h3',
  imageProps: null,
  layout: 'vertical',
  metaData: null,
  mobileAspectRatio: null,
  mobileImageProps: null,
  mobileVideoProps: null,
  overlineHeading: null,
  subContent: '',
  variant: 'default',
  videoProps: null
};
export default Card;